"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toFromNow = exports.format_date = void 0;
var INVALID_DATE = 'Invalid Date';
var format_map = {
  dd: function dd(day) {
    var _day$toString;
    return day === null || day === void 0 || (_day$toString = day.toString()) === null || _day$toString === void 0 ? void 0 : _day$toString.padStart(2, '0');
  },
  Do: {
    1: '1st',
    2: '2nd',
    3: '3rd',
    4: '4th',
    5: '5th',
    6: '6th',
    7: '7th',
    8: '8th',
    9: '9th',
    10: '10th',
    11: '11th',
    12: '12th',
    13: '13th',
    14: '14th',
    15: '15th',
    16: '16th',
    17: '17th',
    18: '18th',
    19: '19th',
    20: '20th',
    21: '21st',
    22: '22nd',
    23: '23rd',
    24: '24th',
    25: '25th',
    26: '26th',
    27: '27th',
    28: '28th',
    29: '29th',
    30: '30th',
    31: '31st'
  },
  MMM: {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec'
  },
  hh: function hh(hours) {
    return hours <= 12 ? hours : hours - 12;
  },
  // only do this when hours > 12
  mm: function mm(minutes) {
    return String(minutes).padStart(2, '0');
  },
  a: function a(hours) {
    if (hours - 12 >= 0) return 'pm';
    return 'am';
  }
};
var format_date = exports.format_date = function format_date(date, format) {
  try {
    var formatted_date = format.split('$').map(function (identifier) {
      if (identifier && Object.keys(format_map).includes(identifier)) {
        switch (identifier) {
          case 'dd':
            return format_map.dd(date.getDate());
          case 'Do':
            return format_map.Do[date.getDate()];
          case 'MMM':
            return format_map.MMM[date.getMonth() + 1];
          // getMonth is zero based
          case 'hh':
            return format_map.hh(date.getHours());
          case 'mm':
            return format_map.mm(date.getMinutes());
          case 'a':
            return format_map.a(date.getHours());
          default:
            return identifier;
        }
      }
      return identifier;
    });
    return formatted_date.join('');
  } catch (e) {
    return INVALID_DATE;
  }
};
var toFromNow = exports.toFromNow = function toFromNow(date) {
  var current_date = new Date();
  var difference = Math.abs(current_date - date);
  var hours = Math.floor(difference / (60 * 60 * 1000));
  var minutes = Math.floor(difference / (60 * 1000));
  var days = Math.floor(difference / (24 * 60 * 60 * 1000));
  var months = Math.floor(difference / (30 * 24 * 60 * 60 * 1000));
  var years = Math.floor(difference / (12 * 30 * 24 * 60 * 60 * 1000));
  if (date < current_date) {
    if (years > 0) if (years === 1) return 'a year ago';else return "".concat(years, " years ago");
    if (months > 0) if (months === 1) return 'a month ago';else return "".concat(months, " months ago");
    if (days > 0) if (days === 1) return 'a day ago';else return "".concat(days, " days ago");
    if (hours > 0) if (hours === 1) return 'an hour ago';else return "".concat(hours, " hours ago");
    if (minutes > 0) if (minutes === 1) return 'a minute ago';else return "".concat(minutes, " minutes ago");
    return 'a few seconds ago';
  }
  if (date > current_date) {
    if (hours > 0) if (hours === 1) return 'in an hour';else return "in ".concat(hours, " hours");
    if (minutes > 0) if (minutes === 1) return 'in a minute';else return "in ".concat(minutes, " minutes");
    return 'in a few seconds';
  }
  return 'just now';
};